/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createMeteringPointSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type MeteringPointSummary, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /meteringpoints/by-address
 */
export interface ByAddressRequestBuilder extends BaseRequestBuilder<ByAddressRequestBuilder> {
    /**
     * GetMeteringPointsByAddress
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<MeteringPointSummary[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ByAddressRequestBuilderGetQueryParameters> | undefined) : Promise<MeteringPointSummary[] | undefined>;
    /**
     * GetMeteringPointsByAddress
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ByAddressRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetMeteringPointsByAddress
 */
export interface ByAddressRequestBuilderGetQueryParameters {
    houseNumber?: string;
    postcode?: string;
}
/**
 * Uri template for the request builder.
 */
export const ByAddressRequestBuilderUriTemplate = "{+baseurl}/meteringpoints/by-address?HouseNumber={HouseNumber}&Postcode={Postcode}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ByAddressRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "houseNumber": "HouseNumber",
    "postcode": "Postcode",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ByAddressRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ByAddressRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createMeteringPointSummaryFromDiscriminatorValue,
        queryParametersMapper: ByAddressRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
